import React from 'react'
import PlaceholderPage from '../../components/shared/PlaceholderPage'
import { FileText } from 'lucide-react'

const features = [
  { name: 'Proposal Details', description: 'View complete proposal information' },
  { name: 'Activity Timeline', description: 'Track all proposal activity and changes' },
  { name: 'Documents', description: 'Attached documents and generated PDFs' },
  { name: 'Communication', description: 'Notes and messages related to proposal' },
]

export default function ProposalDetailView() {
  return (
    <PlaceholderPage
      title="Proposal Details"
      description="View and manage individual proposals"
      icon={FileText}
      features={features}
      accentColor="orange"
    />
  )
}
